import { useMinAndMaxRoomNum } from "@/components/features/items/edit/plan/_shared/ui/components/min-and-max-people-num/hooks";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanMinAndMaxRoomNum = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { minRoomNum, maxRoomNum } = viewModel;

	return useMinAndMaxRoomNum({
		minRoomNum,
		maxRoomNum,
		onSetViewModel,
	});
};
